export default "__VITE_ASSET__DuInpZTS__"